import {Injectable, Injector} from '@angular/core';
import {Router} from "@angular/router";


@Injectable({
  providedIn: 'root',
})
export class RouterService {

  constructor(
    private router: Router
  ) {
  }

  routeToWithRefresh(s: string) {
    this.router.navigateByUrl(s, {skipLocationChange: false}).then(() => {
      window.location.reload()
    });
  }

  routeTo(s: string) {
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
      this.router.navigate([s])
    });
  }

}
